var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24722 10H9.99722L12.6972 15.6925L11.6847 17.5225C11.1372 18.5275 11.8572 19.75 12.9972 19.75H21.2472C21.6597 19.75 21.9972 19.4125 21.9972 19C21.9972 18.5875 21.6597 18.25 21.2472 18.25H12.9972L13.8222 16.75H19.4097C19.9722 16.75 20.4672 16.4425 20.7222 15.9775L23.4072 11.11C23.6847 10.615 23.3247 10 22.7547 10H11.6547L11.1522 8.9275C11.0322 8.665 10.7622 8.5 10.4772 8.5H9.24722C8.83472 8.5 8.49722 8.8375 8.49722 9.25C8.49722 9.6625 8.83472 10 9.24722 10ZM12.9972 20.5C12.1722 20.5 11.5047 21.175 11.5047 22C11.5047 22.825 12.1722 23.5 12.9972 23.5C13.8222 23.5 14.4972 22.825 14.4972 22C14.4972 21.175 13.8222 20.5 12.9972 20.5ZM19.0047 22C19.0047 21.175 19.6722 20.5 20.4972 20.5C21.3222 20.5 21.9972 21.175 21.9972 22C21.9972 22.825 21.3222 23.5 20.4972 23.5C19.6722 23.5 19.0047 22.825 19.0047 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCart);
export default __webpack_public_path__ + "static/media/blue-cart.80920f0d33bd1b6952190aa17f69dd39.svg";
export { ForwardRef as ReactComponent };